import { createAsyncThunk } from '@reduxjs/toolkit';

import ResponseError from '@/errors/responseError';
import invoiceModel from '@/models/invoice';
import paymentModel from '@/models/payment';
import subscriptionModel from '@/models/subscription';
import { fetchBillingInfo } from '@/store/profile/thunks';

export const fetchPayments = createAsyncThunk(
	'billing/fetchPayments',
	async (_, { rejectWithValue, getState }) => {
		try {
			const { page } = getState().billing;
			const params = { ...(page && page > 1 && { page }) };

			return await paymentModel.getPayments({ params });
		} catch (error) {
			if (error instanceof ResponseError) {
				return rejectWithValue({ status: error.status, data: error.data });
			}

			throw error;
		}
	}
);

export const cancelSubscription = createAsyncThunk(
	'billing/cancelSubscription',
	async (_, { rejectWithValue, dispatch }) => {
		try {
			await subscriptionModel.cancelSubscription();
			return await dispatch(fetchBillingInfo());
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const cancelRollback = createAsyncThunk(
	'billing/cancelRollback',
	async (_, { rejectWithValue, dispatch }) => {
		try {
			await subscriptionModel.cancelRollback();
			return await dispatch(fetchBillingInfo());
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const subscribe = createAsyncThunk(
	'billing/subscribe',
	async ({ priceId, currency }, { rejectWithValue, dispatch }) => {
		try {
			await subscriptionModel.subscribe(priceId, currency);
			return await dispatch(fetchBillingInfo());
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const getDownload = createAsyncThunk(
	'billing/getDownload',
	async (_, { rejectWithValue }) => {
		const invoiceId = 1;
		try {
			const response = await invoiceModel.getDownload(invoiceId);

			return response;
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);
